import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 56.43 58.96"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M56.43 17.43c-.62-.53-1.3-.99-2.02-1.36-.87-.3-1.81-.31-2.68-.03-1.01.37-5.71 2.4-10.33 2.34-3.35-.17-6.63-.95-9.69-2.31C31.02 15.79 2.58.09 2.58.09L0 0v.26l1.78.49 19.93 20.08s9.42 7.35 1.76 18.96L12.19 58.95l3.61-1.78 40.63-39.74Z",
      "data-name": "Path 1615",
      style: {"fill":"#ffa300"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "PB-logo"}) } }